import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { serialize } from "../../utils/url";
import { IMissionList } from "../types";

export interface IMissionListQueryParameters extends IPaginateable, IOrderable<"createdAt" | "updatedAt"> {}

export type IMissionListQueryResult = IMissionList;

export const missionListQuery: IApiQueryFunction<IMissionListQueryParameters> = ({ pagination, order }) => {
    return {
        method: "GET",
        url: `/missions${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
            },
            true,
        )}`,
    };
};

export const useMissionListQuery = createApiQueryHook<IMissionListQueryParameters, IMissionListQueryResult>(
    missionListQuery,
);
